/**
 * Builds the payment request body sent to `PUT .../payment`.
 *
 * The endpoint expects the payment data (`paymentMethod` + `quantityInstallments`)
 * wrapped in a `payment` object, with the Cybersource device fingerprint as a
 * sibling `deviceFingerPrint` string.
 *
 * When no fingerprint is available (SDK disabled or not yet generated) the
 * `deviceFingerPrint` field is omitted, so retailers without Cybersource keep
 * sending the exact same payload they do today (minus the new `payment` wrapper).
 *
 * @param {object} payment - the payment data ({ paymentMethod, quantityInstallments? })
 * @param {string|null|undefined} fingerprint - the Cybersource ProviderIdentifier
 * @returns {object} the request body
 */
export function buildPaymentRequestBody(payment, fingerprint) {
	const body = { payment };

	if (fingerprint) body.deviceFingerPrint = fingerprint;

	return body;
}
